// import { addToChainAfter, ApiHandler } from "@insite/client-framework/HandlerCreator";
// import { GetOrdersApiParameter } from "@insite/client-framework/Services/OrderService";
// import { getOrdersDataView } from "@insite/client-framework/Store/Data/Orders/OrdersSelectors";
// import { OrderCollectionModel } from "@insite/client-framework/Types/ApiModels";
// import { getOrderStatus } from "@WhiteCap/Store/Service/OrderDeliveryStatus";

// type HandlerType = ApiHandler<GetOrdersApiParameter, OrderCollectionModel>;
// const recentOrdersParameter: GetOrdersApiParameter = {
//     customerSequence: "-1",
//     page: 1,
//     sort: "OrderDate DESC",
// };
// export const RequestOrderDataFromApi: HandlerType = async props => {
//     const state = props.getState();
//     const ordersDataView = getOrdersDataView(state, recentOrdersParameter).value;
// const ordersDataViewOrderNumber = ordersDataView?.map(o=> o.id);
//     props.apiResult = await getOrderStatus(ordersDataViewOrderNumber);
// };
import { ApiHandler, createHandlerChainRunner } from "@insite/client-framework/HandlerCreator";
import { ApiParameter } from "@insite/client-framework/Services/ApiService";
import { CustomApiHandler } from "@WhiteCap/Store/CustomHandlerCreator/CustomHandlerCreator";
import { getOrderStatus, OrderDeliveryStatus } from "@WhiteCap/Store/Service/OrderDeliveryStatus";

export interface GetOrdersStatusApiParameter extends ApiParameter{
    orderNumber:string[]
}
type HandlerType = CustomApiHandler<GetOrdersStatusApiParameter, OrderDeliveryStatus>;

// export const DispatchBeginLoadOrders: HandlerType = props => {
//     props.dispatch({
//         type: "Data/Orders/BeginLoadOrders",
//         parameter: props.parameter,
//     });
// };

export const PopulateApiParameter: HandlerType = props => {
    props.apiParameter = { ...props.parameter };
};

export const RequestDataFromApi: HandlerType = async props => {
    props.apiResult = await getOrderStatus(props.apiParameter.orderNumber);
};

export const DispatchCompleteLoadOrders: HandlerType = props => {
    props.dispatch({
        type: "Custom/OrdersData/CompletedLoadOrderData",
        result: props.apiResult,
    });
};

export const chain = [PopulateApiParameter, RequestDataFromApi, DispatchCompleteLoadOrders];

const loadOrdersStatus = createHandlerChainRunner(chain, "LoadOrdersStatus");
export default loadOrdersStatus;
